// eslint-disable-next-line import/no-anonymous-default-export
export default {
  aiManage: {
    serviceManagement: {
      name: "服务名称",
      aliasName: "服务别名",
      version: "版本号",
      trialLimited: "试用次数",
      status: "状态",
      changeStatusSuccessfully: "修改服务状态成功",
      changeStatusFailed: "修改服务状态失败",
      aihubServiceName: "AI中心服务名称",
    },

    userManagment: {
      ssoIdentityUid: "客户标识",
      accountType: "账户类型",
      status: "状态",
      enable: "启用",
      disable: "禁用",
      prepaid: "预付",
      noprepaid: "即用即付",
      isSaas: "私有化",
      machineCode: "机器码",
      true: "是",
      false: "否",
      validate: {
        inputSsoId: "请输入客户标识",
        inputName: "请输入客户名",
        inputEmail: "请输入邮箱",
        inputPhone: "请输入联系方式",
        selectStatus: "请选择状态",
        selectAccountType: "请选择账户类型",
        email: "邮箱格式错误",
        phone: "联系方式格式错误",
      },
    },

    userServiceManagement: {
      name: "账户服务管理",
      tip: "提示",
      overdue: "access_token已过期, 请重新登录！",
      note: "注：点击“确认”返回登录页",
      scale: "最大调用次数不可低于0, 高于9999999",
      createService: {
        searchName: "客户名、邮箱或手机号",
        type: "类别",
        formal: "正式",
        trial: "试用",
        maxCallLimited: "最大调用次数",
        used: "已使用量",
        tip: "注：请先勾选再填写服务",
        tiptop: "请输入客户名、邮箱或手机号",
      },
      editService: {
        key: "密钥",
        keyOne: "密钥 1",
        keyTwo: "密钥 2",
        retrieveKeyOne: "重新生成密钥1",
        retrieveKeyTwo: "重新生成密钥2",
        used: "已调用次数",
        tip: "请将服务填写完整",
        tiptop: "请确认名称或服务已填写",
      },
      common: {
        inputName: "请输入客户名",
        inputEmail: "请输入邮箱",
        inputPhone: "请输入联系方式",
        copyOne: "密钥一复制成功",
        copyTwo: "密钥二复制成功",
      },
    },
  },
};
